(() => {
  const FALLBACK_TEXT = 'Selected by Our Experts';

  function buildVariantText(variant) {
    if (!variant || !variant.options || !variant.options.length) {
      return FALLBACK_TEXT;
    }

    const values = variant.options.filter(
      (value) => value && value !== 'Default Title'
    );

    return values.length ? values.join(' - ') : FALLBACK_TEXT;
  }

  function updateVariantSelectionText(sectionId, variant) {
    if (!sectionId) return;

    const textNode = document.getElementById(`cb-pdp-selection-text-${sectionId}`);
    if (!textNode) return;

    textNode.textContent = buildVariantText(variant);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data) return;
        updateVariantSelectionText(data.sectionId, data.variant);
      });
    }
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-scroll-open-target]');
    if (!trigger) return;

    event.preventDefault();

    const targetSelector = trigger.getAttribute('data-scroll-open-target');
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    const detailsParent = target.closest('details');
    if (detailsParent && !detailsParent.hasAttribute('open')) {
      detailsParent.setAttribute('open', '');
    }

    setTimeout(() => {
      const y = target.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }, 120);
  });
})();